import { render } from "./BlackboxDetails.vue?vue&type=template&id=3463e9b8"
import script from "./BlackboxDetails.vue?vue&type=script&lang=js"
export * from "./BlackboxDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__